import React, { forwardRef, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import 'moment/locale/pt-br';
import br from 'date-fns/locale/pt-BR';

registerLocale('br', br);

const TimeField = forwardRef((props, ref) => {
    
    const getInitialTime = () => {
        const isValidTime = (time) => time.includes(':') && (time.length === 5 || time.length === 8);
        if (props.value && isValidTime(props.value)) {
            return moment(`2000-01-01 ${props.value}:00`).toDate();
        }
        if (props.defaultValue && isValidTime(props.defaultValue)) {
            return moment(`2000-01-01 ${props.defaultValue}:00`).toDate();
        }
        return null;
    };    

    const [value, setValue] = useState(getInitialTime());
    let className = "form-control" + (props.error ? " is-invalid" : "");

    useEffect(() => {
        if (props.defaultValue && !props.value) {
            const defaultTime = moment(`2000-01-01 ${props.defaultValue}:00`).toDate();
            setValue(defaultTime);
            handleChange(defaultTime);
        }
    }, [props.defaultValue, props.value]);

    const handleChange = date => {
        setValue(date);
        const formattedTime = moment(date).format("HH:mm");
        props.onChange({ target: { name: props.name, type: 'time', value: formattedTime } });
    };

    return (
        <div ref={ref}>
            {!props.readOnly && (
                <DatePicker
                    id={`id_${props.name}`}
                    name={props.name}
                    selected={value}
                    onChange={handleChange}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="HH:mm"
                    locale="br"
                    className={className}
                />
            )}
            {props.readOnly && value && (
                <span>{moment(value).format("HH:mm")}</span>
            )}
            {props.error && (
                <span className="error invalid-feedback" style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
});

export default TimeField;